import { DiscordSDK } from '@discord/embedded-app-sdk'

export interface DiscordActivityContext {
  status: 'local' | 'ready' | 'error'
  label: string
  guildId?: string
  channelId?: string
  instanceId?: string
  accessToken?: string
  userId?: string
  authStatus?: 'skipped' | 'authenticated' | 'failed'
}

export async function initializeDiscordSdk(
  clientId: string | null | undefined
): Promise<DiscordActivityContext> {
  if (!clientId) {
    return {
      status: 'local',
      label: 'Preview local',
      authStatus: 'skipped'
    }
  }

  try {
    const sdk = new DiscordSDK(clientId)
    await sdk.ready()
    const auth = await authenticateActivity(sdk, clientId)
    return {
      status: 'ready',
      label: auth.accessToken ? 'Discord autenticado' : 'Discord pronto',
      guildId: sdk.guildId ?? undefined,
      channelId: sdk.channelId ?? undefined,
      instanceId: sdk.instanceId ?? undefined,
      accessToken: auth.accessToken,
      userId: auth.userId,
      authStatus: auth.accessToken ? 'authenticated' : 'failed'
    }
  } catch {
    return {
      status: 'error',
      label: 'SDK offline',
      authStatus: 'failed'
    }
  }
}

async function authenticateActivity(
  sdk: DiscordSDK,
  clientId: string
): Promise<{ accessToken?: string; userId?: string }> {
  try {
    const authorization = await sdk.commands.authorize({
      client_id: clientId,
      response_type: 'code',
      scope: ['identify', 'guilds']
    })

    const tokenResponse = await fetch('/api/discord/token', {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json'
      },
      body: JSON.stringify({
        code: authorization.code,
        redirectUri: window.location.origin
      })
    })
    if (!tokenResponse.ok) return {}

    const token = await tokenResponse.json().catch(() => null) as {
      accessToken?: string
    } | null
    if (!token?.accessToken) return {}

    const authenticated = await sdk.commands.authenticate({
      access_token: token.accessToken
    })
    return {
      accessToken: authenticated.access_token,
      userId: authenticated.user.id
    }
  } catch {
    return {}
  }
}
